import { appData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function AppSection() {
  const ref = useScrollReveal();
  return (
    <section id="app" ref={ref} className="reveal-section py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-4xl mx-auto">
          <div className="bg-foreground-950 rounded-lg overflow-hidden">
            <div className="flex flex-col lg:flex-row items-stretch">
              <div className="flex-1 p-8 md:p-10 flex flex-col justify-center">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
                  {appData.title}
                </h2>
                <p className="text-foreground-400 text-sm leading-relaxed mb-6">
                  {appData.desc}
                </p>
                <div className="space-y-2 mb-6">
                  {appData.features.map((f, i) => (
                    <div key={i} className="flex items-center gap-2 text-foreground-300 text-sm">
                      <i className="ri-checkbox-circle-fill text-accent-500"></i>
                      <span>{f}</span>
                    </div>
                  ))}
                </div>
                <button className="w-full sm:w-auto px-8 py-3.5 rounded-md bg-accent-500 hover:bg-accent-600 text-foreground-950 font-semibold text-sm transition-all cursor-pointer whitespace-nowrap">
                  <i className="ri-download-2-line mr-2"></i>
                  {appData.ctaText}
                </button>
              </div>
              <div className="lg:w-[280px] flex-shrink-0 bg-foreground-900 flex items-center justify-center p-8">
                <div className="bg-white p-3 rounded-lg">
                  <img
                    src={appData.qrImage}
                    alt="91精品影视下载工具二维码"
                    className="w-40 h-40 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}